// extracted by mini-css-extract-plugin
export default {"cards":"styles_cards__Cg8CD","card":"styles_card__VAb7+"};